<template>
  <div class="phy_wrap">
    <div class="organ">
      <div class="tabbar">
        <div
          :class="activeIndex == 0 ? 'active' : ''"
          @click="changeTapData(0)"
        >
          器官
        </div>
        <div
          :class="activeIndex == 1 ? 'active' : ''"
          @click="changeTapData(1)"
        >
          脊椎
        </div>
      </div>
      <div class="marks">
        <div>{{ marks }}</div>
        健康度
      </div>
      <div
        v-if="activeIndex == 0"
        :class="sex == 1 ? 'manperson person' : 'person womanperson'"
      >
        <img
          v-if="sex == 1"
          mode="widthFix"
          class="man_bg"
          src="../assets/image/qiguan/man_body.png"
        />
        <img
          v-if="sex == 2"
          mode="widthFix"
          class="man_bg"
          src="../assets/image/qiguan/woman_body.png"
        />
        <div id="humanImg">
          <template v-for="(item, index) in organlist">
            <img
              v-if="item.imgurl"
              :key="index"
              :class="item.icon"
              :src="item.avaturl"
              :data-icon="item.icon"
              v-show="item.disShow"
            />
            <!-- <div v-else class="circles"></div> -->
          </template>
        </div>
      </div>
      <div v-if="activeIndex == 1" class="vertebra">
        <div id="humanImg">
          <template v-for="(item, index) in vertebralist">
            <img
              :key="index"
              v-if="item.imgurl"
              :class="item.imgurl"
              :src="item.avaturl"
              :data-icon="item.icon"
            />
          </template>
        </div>
      </div>
      <div class="organ_list">
        <div class="list_top">
          <div class="ttba">
            免疫风险等级
            <img
              @click="showDialog"
              src="http://img.xiaoqijiankang.com/images/wenhao.png"
            />
          </div>
          <div class="risks">
            <div
              :class="index == statusIndex ? 'riskActive' : ''"
              v-for="(item, index) in ristStatus"
              :key="index"
              @click="changeStatus(item.id)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <img class="list_middle" src="../assets/image/concact.png" />
        <div class="list_bottom">
          <div v-if="risklist.length != 0" class="risks">
            <div
              :class="activeOrgan.name == item.name ? 'orgActive' : ''"
              v-if="item.name"
              v-for="(item, index) in risklist"
              :key="index"
              @click="handleOrgan(item)"
            >
              {{ item.name }}
            </div>
          </div>
          <div v-else class="noOrgan">该风险暂无器官</div>
        </div>
        <!-- <img class="list_middle" src="../assets/image/concact.png"></img>
                <div class="text-box">
                  <div>
                    免疫力是人体自身的防御机制，是人体识别和消灭外来侵入的任何异物（病毒、细菌等）、处理衰老、损伤、死亡、变性的自身细胞以及识别和处理体内突变细胞和病毒感染细胞的能力。
                  </div>
                  <div>
                    免疫风险越高：越容易生病，加重机体的消耗，一般有体质虚弱、营养不良、精神萎靡、疲乏无力、食欲降低、睡眠障碍等表现。通常每次生病的恢复时间都比较长，而且容易反复发作。
                  </div>
                  <div>
                    在疾病发生前及早发现免疫风险，有助于疾病预防、促进健康。该评估为功能性评价，不作为临床诊断结论，可作为辅助数据参考，同时客户可结合自身症状咨询专业医生进行有针对性的健康管理。
                  </div>
              </div> -->
      </div>
      <!-- 弹层 -->
      <div v-show="showOrganDialog" class="dialog">
        <!-- <div class="rowLine">
          <img class="blueCircle" src="../assets/image/organCircle.png" />
        </div>
        <div class="colLine"></div> -->
        <div class="box">
          <div class="boxTop">{{ activeOrgan.name }}</div>
          <div class="status">
            <div>
              <span>功能状态：</span>{{ activeOrgan.functional_status }}
            </div>
            <div><span>修复能力：</span>{{ activeOrgan.transition }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import json from '@/utils/json'
import { ossUrl } from "@/config";
export default {
  props: ['list'],
  data () {
    return {
      noHealth: true, //是否有检测数据
      activeIndex: 0, //当前显示 0 人体 ，1 脊椎
      ristStatus: [{ name: '低', id: 1 },
      { name: '偏低', id: 2 },
      { name: '中', id: 3 },
      { name: '偏高', id: 4 },
      { name: '高', id: 5 }], // 免疫风险等级
      organlist: [], //人体器官
      risklist: [], //风险器官列表
      vertebralist: [], //脊椎列表
      sex: 2, //性别,
      statusIndex: 0,
      activeOrgan: {},
      marks: '', //当前报告分数，
      showOrganDialog: false,
      datalist: this.list
    }
  },
  watch: {
    list (newVal) {

      console.log('list的值改变啦啦啦啦啦啦啦')
      console.log('newVal', newVal)
      this.datalist = newVal
      this.getReport()
    }
  },
  methods: {
    showDialog () {
      this.$emit('show-dialog')
    },
    /**切换弹层器官展示 */
    handleOrgan (item) {
      let list = this.activeIndex == 1 ? 'allOrgan_vertebra' : this.sex == 1 ? 'allOrgan_man_arr' : 'allOrgan_woman_arr';

      let activeOrgan = {}
      json[list].forEach(ele => {
        if (item.icon == ele.icon) {
          item.top = ele.top;
          item.left = ele.left;
          activeOrgan = item;
        }
      });
      this.activeOrgan = activeOrgan
      this.recalc(item)
      this.showOrganDialog = true
    },
    /**当前器官闪动 */
    recalc (item) {
      console.log(item)
      let that = this
      if (item.icon == 'ear_right' || item.icon == 'ear_left' || item.icon == 'eye_right' || item.icon == 'eye_left' || item.icon == 'tonsil_right' || item.icon == 'tonsil_left' || item.icon == 'carotid_left' || item.icon == 'carotid_right' || item.icon == 'throat' || item.icon == 'nose_left' || item.icon == 'nose_right') {
        this.organlist.forEach((e) => {
          if (e.icon == 'ear_right' || e.icon == 'ear_left' || e.icon == 'eye_right' || e.icon == 'eye_left' || e.icon == 'tonsil_right' || e.icon == 'tonsil_left' || e.icon == 'carotid_left' || e.icon == 'carotid_right' || e.icon == 'throat' || e.icon == 'nose_right' || e.icon == 'nose_left') {
            e.disShow = false
          }
        })
        item.disShow = true
        console.log(item)
      } else {
        this.organlist.forEach((e) => {
          if (e.icon == 'ear_right' || e.icon == 'ear_left' || e.icon == 'eye_right' || e.icon == 'eye_left' || e.icon == 'tonsil_right' || e.icon == 'tonsil_left' || e.icon == 'carotid_left' || e.icon == 'carotid_right' || e.icon == 'throat' || e.icon == 'nose_right' || e.icon == 'nose_left') {
            e.disShow = false
          }
        })
      }
      try {
        that.$nextTick(() => {
          let humanImg = document.querySelector('#humanImg')
          let imgItem = humanImg.querySelectorAll('img')
          if (item.icon == 'sacral_2' || item.icon == 'sacral_3' || item.icon == 'sacral_4' || item.icon == 'sacral_5') {
            for (var i = 0; i <= imgItem.length; i++) {

              try {
                if (imgItem[i].getAttribute('data-icon') == 'sacral_1') {
                  imgItem[i].className.indexOf('activeImg') == -1 ? imgItem[i].className = `${imgItem[i].className} activeImg` : ''

                } else {
                  imgItem[i].className = imgItem[i].getAttribute('data-icon')
                }
              } catch (error) {
              }
            }

          } else {
            for (var i = 0; i <= imgItem.length; i++) {
              try {
                if (imgItem[i].getAttribute('data-icon') == item.icon) {
                  imgItem[i].className.indexOf('activeImg') == -1 ? imgItem[i].className = `${imgItem[i].className} activeImg` : ''

                } else {
                  imgItem[i].className = imgItem[i].getAttribute('data-icon')
                }
              } catch (error) {
              }
            }
          }

        })
      } catch (error) {

      }

    },
    changeStatus (id) {
      this.handleOrganlist(id)
      this.statusIndex = id - 1
      this.showOrganDialog = false

    },
    /**器官脊椎tab切换 */
    handleOrganlist (id) {
      let risklist = [];
      let list = this.activeIndex == 0 ? 'organlist' : 'vertebralist'
      this[list].forEach(e => {
        if (e.level === id && e.icon !== "nose") {
          risklist.push(e)
        }
        this.risklist = risklist
      })
    },
    /**获取报告详情 */
    getReport () {
      let organlist = this.datalist.human,
        vertebralist = this.datalist.vertebra,
        noIconArr = [
        ],
        sexrr = ['upper_left', 'upper_right', 'the_xiao_left', 'the_xiao_right', 'the_da_right', 'the_da_left'];
      if (this.list.human.length === 0) {
        this.noHealth = true
      }
      organlist.forEach((e) => {
        e.imgstatus = e.level == 1 ? 1 : e.level <= 3 ? 2 : 3;
        e.disShow = true;
        if (e.icon == 'ear_right' || e.icon == 'ear_left' || e.icon == 'eye_right' || e.icon == 'eye_left' || e.icon == 'tonsil_right' || e.icon == 'tonsil_left' || e.icon == 'carotid_left' || e.icon == 'carotid_right' || e.icon == 'throat' || e.icon == 'nose_right' || e.icon == 'nose_left') {
          e.disShow = false
        } else {

        }
        if (noIconArr.includes(e.icon) || e.icon == '') {
          e.imgurl = null
        } else if (sexrr.includes(e.icon)) {
          let sex = this.sex == 1 ? 'man' : 'woman'
          e.imgurl = sex + e.icon
          e.avaturl = `${ossUrl}/qiguan/${e.imgurl}${e.imgstatus}.png`
        } else {
          e.imgurl = e.icon;
          e.avaturl = `${ossUrl}/qiguan/${e.imgurl}${e.imgstatus}.png`
        }
      })
      vertebralist.forEach(e => {
        e.imgstatus = e.level == 1 ? 1 : e.level <= 3 ? 2 : 3;
        if (e.icon === 'sacral_1') {
          e.imgurl = 'sacral'
          e.avaturl = `${ossUrl}/jizhui/${e.imgurl}_${e.imgstatus}.png`
        } else if (e.icon.indexOf('sacral') != -1) {
          e.imgurl = null
        } else {
          e.imgurl = e.icon
          e.avaturl = `${ossUrl}/jizhui/${e.imgurl}_${e.imgstatus}.png`
        }
      })

      let nosename = this.sex == 1 ? 'mannose' : 'womannose'
      let nose = {
        icon: 'nose',
        name: "鼻子",
        imgurl: nosename,
        disShow: true,
        avaturl: `${ossUrl}/qiguan/nose${organlist[24].level == 1 ? 1 : organlist[24].level < 4 ? 2 : 3}.png`,
        level: organlist[24].level
      }
      organlist.push(nose);
      this.organlist = organlist;
      this.vertebralist = vertebralist;

      this.noHealth = false;
      this.handleOrganlist(1)
    },
    /**初始化器官/脊椎 */
    changeTapData (number) {
      this.activeIndex = number,
        this.showOrganDialog = false
      this.handleOrganlist(1)
    },
  },
  created () {
    this.sex = this.datalist.sex;
    this.marks = this.datalist.marks;
    this.datalist.human.splice(20, 1)
    this.getReport()
  }
}
</script>
<style lang="scss" scoped>
.phy_wrap {
  width: 100%;
  height: 100%;
  margin: auto;
  overflow: auto;
}
/**index.wxss**/
.organ {
  position: relative;
  z-index: 22;
  background-image: url(../assets/image/index_bgs.jpg);
  width: 100%;
  height: 100%;
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-color: #b9dee8;
  // padding-bottom: 10px;
  overflow: hidden;
}
.marks {
  position: absolute;
  top: 120px;
  right: 30px;
  width: 160px;
  height: 160px;
  background-size: 100%;
  background-repeat: no-repeat;
  color: #929292;
  font-size: 20px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  background-image: url(../assets/image/grade_bg.png);
}
.marks div {
  font-size: 48px;
  color: #1681e1;
  font-weight: bold;
  text-align: center;
  margin: 30px auto 0;
  height: 50px;
  width: 110px;
}
/* 顶部tab */
.tabbar {
  width: 710px;
  padding: 15px 0;
  margin: auto;
  display: flex;
  justify-content: space-between;
}
.addTo {
  position: fixed;
  top: 80px;
  left: 0;
  right: 0;
  z-index: 5;
}
.tabbar div {
  flex: 1;
  background-color: #82d1ff;
  color: #fff;
  text-align: center;
  height: 70px;
  line-height: 70px;
}
.tabbar div:first-child {
  border-radius: 5px 0 0 5px;
}
.tabbar div:last-child {
  border-radius: 0 5px 5px 0;
}
.tabbar div.active {
  background-color: #2e94e5;
}
/* 人体图 */
.person {
  position: relative;
  width: 351px;
  height: auto;
  max-height: 877px;
  overflow: hidden;
  margin: auto;
  top: 60px;
  animation: shows linear 0.35s;
  animation-fill-mode: forwards;
}
.person .man_bg {
  width: 100%;
}
.person .brain_left {
  position: absolute;
  right: 148px;
  top: 8px;
  width: 23px;
}
.person .brain_right {
  position: absolute;
  left: 150px;
  top: 8px;
  width: 23px;
}
.person .lung_left {
  position: absolute;
  right: 109px;
  top: 139px;
  width: 63px;
}
.person .lung_right {
  position: absolute;
  left: 107px;
  top: 139px;
  width: 63px;
}
.person .liver {
  position: absolute;
  left: 114px;
  top: 234px;
  width: 80px;
}
.person .kidney_left {
  position: absolute;
  right: 131px;
  top: 256px;
  width: 41px;
  z-index: 1;
}
.person .kidney_right {
  position: absolute;
  left: 133px;
  top: 256px;
  width: 41px;
}
.person .pancreas {
  position: absolute;
  left: 172px;
  top: 280px;
  width: 40px;
}
.person .heart {
  position: absolute;
  left: 175px;
  top: 170px;
  width: 51px;
}
.manperson .nose {
  position: absolute;
  top: 54px;
  left: 169px;
  width: 14px;
}

.person .trachea_q {
  position: absolute;
  left: 168px;
  top: 113px;
  width: 12px;
}
.person .trachea_z {
  position: absolute;
  left: 162px;
  top: 159px;
  width: 28px;
  z-index: 1;
}
.person .gullet {
  position: absolute;
  width: 36px;
  left: 163px;
  top: 112px;
}
.person .stomach {
  position: absolute;
  left: 150px;
  top: 220px;
  width: 86px;
}
.person .intestine_12 {
  position: absolute;
  left: 158px;
  top: 275px;
  width: 40px;
}
.person .intestine_da {
  position: absolute;
  left: 114px;
  top: 280px;
  width: 119px;
}
.person .intestine_xiao {
  position: absolute;
  left: 126px;
  top: 304px;
  width: 99px;
}
.person .spleen {
  position: absolute;
  left: 213px;
  top: 226px;
  width: 33px;
}
.person .thyroid {
  position: absolute;
  left: 161px;
  top: 124px;
  width: 26px;
}
.person .gallbladder {
  position: absolute;
  left: 118px;
  top: 269px;
  width: 22px;
}
.person .bladder {
  position: absolute;
  left: 159px;
  top: 412px;
  width: 36px;
}
.person .andrology_q {
  position: absolute;
  left: 154px;
  top: 418px;
  width: 44px;
}
.person .andrology_left {
  position: absolute;
  right: 147px;
  top: 401px;
  width: 20px;
}
.person .andrology_right {
  position: absolute;
  left: 148px;
  top: 401px;
  width: 20px;
}
.person .breast_left {
  position: absolute;
  right: 119px;
  top: 205px;
  width: 20px;
}
// 开始
.person .breast_right {
  position: absolute;
  left: 119px;
  top: 205px;
  width: 20px;
}
.person .throat {
  position: absolute;
  right: 165px;
  top: 100px;
  width: 20px;
}
.person .eye_left {
  position: absolute;
  right: 150px;
  top: 40px;
  width: 20px;
}
.person .eye_right {
  position: absolute;
  left: 150px;
  top: 40px;
  width: 20px;
}
.person .ear_left {
  position: absolute;
  right: 130px;
  top: 50px;
  width: 20px;
}
.person .ear_right {
  position: absolute;
  left: 130px;
  top: 50px;
  width: 20px;
}
.person .tonsil_left {
  position: absolute;
  right: 155px;
  top: 85px;
  width: 20px;
}
.person .tonsil_right {
  position: absolute;
  left: 155px;
  top: 85px;
  width: 20px;
}
.person .nose_left {
  position: absolute;
  right: 160px;
  top: 60px;
  width: 20px;
}
.person .nose_right {
  position: absolute;
  left: 160px;
  top: 60px;
  width: 20px;
}
.person .adrenal {
  position: absolute;
  left: 140px;
  top: 250px;
  width: 20px;
}
.person .carotid_left {
  position: absolute;
  right: 140px;
  top: 80px;
  width: 20px;
}
.person .carotid_right {
  position: absolute;
  left: 140px;
  top: 80px;
  width: 20px;
}
.manperson .gullet {
  position: absolute;
  width: 36px;
  left: 163px;
  top: 112px;
}
.person .hip_right {
  position: absolute;
  left: 105px;
  top: 400px;
  width: 20px;
}
.person .hip_left {
  position: absolute;
  right: 100px;
  top: 400px;
  width: 20px;
}
.person .shoulder_left {
  position: absolute;
  right: 78px;
  top: 145px;
  width: 48px;
}
.person .shoulder_right {
  position: absolute;
  left: 74px;
  top: 145px;
  width: 48px;
}
// 结束
.manperson .thyroid {
  position: absolute;
  left: 161px;
  top: 130px;
  width: 26px;
}
.manperson .throat {
  position: absolute;
  right: 165px;
  top: 110px;
}
.manperson .tonsil_left {
  position: absolute;
  right: 150px;
  top: 100px;
  width: 20px;
}
.manperson .tonsil_right {
  position: absolute;
  left: 150px;
  top: 100px;
  width: 20px;
}
.manperson .carotid_left {
  position: absolute;
  right: 135px;
  top: 90px;
  width: 20px;
}
.manperson .carotid_right {
  position: absolute;
  left: 135px;
  top: 90px;
  width: 20px;
}
.manperson .nose_left {
  position: absolute;
  right: 160px;
  top: 65px;
  width: 20px;
}
.manperson .nose_right {
  position: absolute;
  left: 160px;
  top: 65px;
  width: 20px;
}
.manperson .eye_left {
  position: absolute;
  right: 145px;
  top: 45px;
  width: 20px;
}
.manperson .eye_right {
  position: absolute;
  left: 147px;
  top: 45px;
  width: 20px;
}
.manperson .ear_left {
  position: absolute;
  right: 120px;
  top: 55px;
  width: 20px;
}
.manperson .ear_right {
  position: absolute;
  left: 123px;
  top: 55px;
  width: 20px;
}
.manperson .upper_left {
  position: absolute;
  right: 23px;
  top: 176px;
  width: 88px;
}
.manperson .upper_right {
  position: absolute;
  left: 23px;
  top: 176px;
  width: 88px;
}

.manperson .the_da_left {
  position: absolute;
  right: 84px;
  top: 450px;
  width: 96px;
}
.manperson .the_da_right {
  position: absolute;
  left: 84px;
  top: 450px;
  width: 96px;
}
.person .knee_left {
  position: absolute;
  right: 114px;
  top: 615px;
  width: 50px;
}
.person .knee_right {
  position: absolute;
  left: 114px;
  top: 615px;
  width: 50px;
}
.manperson .the_xiao_left {
  position: absolute;
  right: 104px;
  top: 665px;
  width: 70px;
}
.manperson .the_xiao_right {
  position: absolute;
  left: 104px;
  top: 665px;
  width: 70px;
}
/* 女生样式 */
.womanperson .brain_left {
  position: absolute;
  right: 152px;
  top: 10px;
  width: 23px;
}
.womanperson .brain_right {
  position: absolute;
  left: 152px;
  top: 10px;
  width: 23px;
}
.womanperson .nose {
  position: absolute;
  top: 53px;
  left: 169px;
  width: 11px;
}
.womanperson .shoulder_left {
  position: absolute;
  right: 78px;
  top: 145px;
  width: 48px;
}
.womanperson .shoulder_right {
  position: absolute;
  left: 74px;
  top: 145px;
  width: 48px;
}
.womanperson .upper_left {
  position: absolute;
  right: 29px;
  top: 180px;
  width: 82px;
}
.womanperson .upper_right {
  position: absolute;
  left: 27px;
  top: 180px;
  width: 82px;
}
.womanperson .the_da_left {
  position: absolute;
  right: 94px;
  top: 455px;
  width: 84px;
}
.womanperson .the_da_right {
  position: absolute;
  left: 94px;
  top: 455px;
  width: 84px;
}
.womanperson .knee_left {
  position: absolute;
  right: 114px;
  top: 595px;
  width: 50px;
}
.womanperson .knee_right {
  position: absolute;
  left: 114px;
  top: 595px;
  width: 50px;
}
.womanperson .the_xiao_left {
  position: absolute;
  right: 100px;
  top: 647px;
  width: 65px;
}
.womanperson .the_xiao_right {
  position: absolute;
  left: 110px;
  top: 647px;
  width: 65px;
}
.uterus {
  position: absolute;
  left: 155px;
  top: 388px;
  width: 51px;
}
.person circle {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: transparent;
}
.activeImg {
  z-index: 999 !important;
  animation: light 0.5s ease infinite alternate;
}

@keyframes light {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
/* 免疫风险等级  + 器官列表 */
.organ_list {
  width: 720px;
  margin: 142px auto 0;
  padding-bottom: 30px;
}
.list_top {
  padding: 28px 20px 38px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 4px 0 rgba(7, 0, 2, 0.3);
  .ttba {
    display: flex;
    align-items: center;
    text-align: left;
    img {
      width: 45px;
      margin-left: 10px;
    }
  }
}
.risks {
  width: 680px;
  margin: 25px auto;
  display: flex;
  justify-content: space-between;
}
.risks div {
  position: relative;
  width: 130px;
  height: 60px;
  color: #fff;
  background-color: #aaa;
  text-align: center;
  line-height: 60px;
  border-radius: 30px;
}
.list_middle {
  position: relative;
  margin: -14px auto 0;
  width: 687px;
  height: 58px;
  display: block;
}
.list_bottom {
  margin-top: -14px;
  // height: auto;
  background-color: #fff;
  padding: 30px 0;
}
.list_bottom .risks {
  width: 680px;
  margin: 20px auto 0;
  display: flex;
  height: 270px;
  justify-content: start;
  flex-wrap: wrap;
  overflow-y: auto;
}
.risks div::before {
  content: "";
  position: absolute;
  bottom: -16px;
  left: 5%;
  width: 90%;
  height: 6px;
  border-radius: 6px;
}
// .risks>div:first-child.riskActive{
//   background: linear-gradient(to right,#6EF086,#30D24E);
// }
.risks > div:first-child.riskActive::before {
  background: linear-gradient(to right, #6ef086, #30d24e);
}
// .risks>div:nth-child(2).riskActive{
//   background: linear-gradient(to right,#A2E317,#6EF086);
// }
.risks > div:nth-child(2).riskActive::before {
  background: linear-gradient(to right, #feae63, #feae63);
}
// .risks>div:nth-child(3).riskActive{
//   background: linear-gradient(to right,#EBA059,#FF891C);
// }
.risks > div:nth-child(3).riskActive::before {
  background: linear-gradient(to right, #eba059, #ff891c);
}
// .risks>div:nth-child(4).riskActive{
//   background: linear-gradient(to right,#FF7C7C,#EE5151);
// }
.risks > div:nth-child(4).riskActive::before {
  background: linear-gradient(to right, #ff7c7c, #ee5151);
}
// .risks>div:nth-child(5).riskActive{
//   background: linear-gradient(to right,#EF5454,#E82C2C);
// }
.risks > div:nth-child(5).riskActive::before {
  background: linear-gradient(to right, #ef5454, #e82c2c);
}
.list_top .risks > div:first-child {
  background: linear-gradient(to right, #6ef086, #30d24e);
}
.list_top .risks > div:nth-child(2) {
  background: linear-gradient(to right, #feae63, #feae63);
}
.list_top .risks > div:nth-child(3) {
  background: linear-gradient(to right, #eba059, #ff891c);
}
.list_top .risks > div:nth-child(4) {
  background: linear-gradient(to right, #ff7c7c, #ee5151);
}
.list_top .risks > div:nth-child(5) {
  background: linear-gradient(to right, #ef5454, #e82c2c);
}
.list_bottom .risks div {
  background-color: #fff;
  color: #1681e1;
  font-size: 28px;
  width: 162px;
  border: 1px solid #1681e1;
  margin-bottom: 16px;
  margin-left: 10px;
  width: 157px;
}
.list_bottom .risks div.orgActive {
  color: #fff;
  border: 1px solid #fff;
  background-color: #1681e1;
}
.list_bottom .risks div:nth-child(4n + 1) {
  margin-left: 0;
}
.text-box {
  width: 700px;
  margin: -15px auto 10px;
  padding: 15px;
  background-color: #fff;
  font-size: 26px;
  text-align: left;
}
.text-box > div {
  text-indent: 60px;
  margin: 10px 0;
}
.noOrgan {
  height: 270px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  color: #999;
}
/* 脊椎 */
.vertebra {
  animation: shows linear 0.35s;
  animation-fill-mode: forwards;
  text-align: center;
  padding-top: 60px;
  position: relative;
  width: 100%;
  height: auto;
  height: 650px;
  overflow: hidden;
  top: 90px;
}
.vertebra img {
  position: absolute;
}
.neck_1 {
  top: 0;
  width: 44px;
  left: 325px;
}
.neck_2 {
  top: 25px;
  width: 45px;
  left: 323px;
}
.neck_3 {
  width: 46px;
  top: 36px;
  left: 321px;
}
.neck_4 {
  width: 44px;
  top: 50px;
  left: 320px;
}
.neck_5 {
  width: 42px;
  top: 61px;
  left: 320px;
}
.neck_6 {
  width: 48px;
  top: 75px;
  left: 322px;
}
.neck_7 {
  width: 56px;
  top: 88px;
  left: 325px;
}
.chest_1 {
  width: 57px;
  top: 105px;
  left: 331px;
}
.chest_2 {
  width: 58px;
  top: 121px;
  left: 338px;
}
.chest_3 {
  width: 62px;
  top: 144px;
  left: 345px;
}
.chest_4 {
  width: 64px;
  top: 167px;
  left: 349px;
}
.chest_5 {
  width: 65px;
  top: 190px;
  left: 355px;
}
.chest_6 {
  width: 65px;
  top: 213px;
  left: 359px;
}
.chest_7 {
  width: 64px;
  top: 236px;
  left: 361px;
}
.chest_8 {
  width: 64px;
  top: 262px;
  left: 361px;
}
.chest_9 {
  width: 64px;
  top: 288px;
  left: 358px;
}
.chest_10 {
  width: 66px;
  top: 313px;
  left: 353px;
}
.chest_11 {
  width: 68px;
  top: 339px;
  left: 349px;
}
.chest_12 {
  width: 72px;
  top: 366px;
  left: 340px;
}
.waist_1 {
  width: 74px;
  top: 395px;
  left: 333px;
}
.waist_2 {
  width: 80px;
  top: 432px;
  left: 326px;
}
.waist_3 {
  width: 80px;
  top: 466px;
  left: 323px;
}
.waist_4 {
  width: 79px;
  top: 500px;
  left: 320px;
}
.waist_5 {
  width: 79px;
  top: 528px;
  left: 321px;
}
.sacral {
  width: 85px;
  top: 560px;
  left: 324px;
}
.sacral_1 {
  width: 85px;
  top: 560px;
  left: 324px;
}
.sacral_2 {
  width: 85px;
  top: 560px;
  left: 324px;
}
.sacral_3 {
  width: 85px;
  top: 560px;
  left: 324px;
}
.sacral_4 {
  width: 85px;
  top: 560px;
  left: 324px;
}
.sacral_5 {
  width: 85px;
  top: 560px;
  left: 324px;
}
.tail {
  width: 26px;
  top: 665px;
  left: 380px;
}
:root {
  --top: 210px;
  --left: 227px;
}
/* 器官状态弹层 */
.dialog {
  position: absolute;
  top: 80px;
  left: 30px;
  width: 360px;
  height: auto;
}
.dialog .rowLine {
  position: absolute;
  top: 0;
  width: 160px;
  border-top: 1px dashed #5fc5e0;
  animation: shows linear 0.35s;
  animation-delay: 0.25s;
  animation-fill-mode: forwards;
}
.dialog .rowLine .blueCircle {
  position: absolute;
  top: -12px;
  left: 0;
  width: 24px;
  height: 24px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  animation: shows linear 0.25s;
  animation-fill-mode: forwards;
}
.rightDialog .rowLine {
  left: -42px;
}
.rightDialog .rowLine .blueCircle {
  left: -12px;
}
.leftDialog .rowLine {
  left: 120px;
}
.leftDialog .rowLine .blueCircle {
  left: 164px;
}
.dialog .colLine {
  position: absolute;
  top: 0;
  left: 121px;
  height: 44px;
  border-left: 1px dashed #5fc5e0;
  animation: shows linear 0.25s;
  animation-delay: 0.6s;
  animation-fill-mode: forwards;
}
.dialog .box {
  position: absolute;
  top: 44px;
  left: 0;
  width: 245px;
  height: 160px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  // animation: shows linear 0.5s;
  // animation-delay: 0.8s;
  // animation-fill-mode: forwards;
  background-image: url("../assets/image/dialog.png");
  padding: 0;
}
.dialog .box .boxTop {
  width: 100%;
  height: 50px;
  background-color: #60c5ff;
  line-height: 50px;
  color: #0466bd;
  font-size: 28px;
  text-align: center;
  margin: auto;
  font-weight: bold;
}
.dialog .box .status {
  padding: 0 18px;
}
.dialog .box .status div {
  color: #808080;
  font-size: 24px;
  margin-top: 10px;
}
.dialog .box .status div span {
  color: #1681e1;
  font-size: 28px;
}
/* 动画效果 */
/* 器官脊椎切换 */
@keyframes shows {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.picker_dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 110px;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 100;
}
.picker_wrap {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
}
.pick_btn {
  display: flex;
  font-size: 26px;
  justify-content: space-between;
  height: 60px;
  background-color: #fff;
}
.picker_item {
  width: 100%;
  height: 420px;
  background-color: #fff;
  text-align: center;
  z-index: 10;
  margin-top: 15px;
}
.pick_btn {
  padding: 0 30px;
  height: 85px;
  border-bottom: 1px solid #ddd;
}
.pick_btn > div {
  width: 120px;
  font-size: 34px;
  text-align: center;
  padding: 25px 0;
}
.risk_status {
  display: flex;
  margin: 15px auto 0;
  width: 350px;
}
.risk_status div {
  width: 68px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  background-color: #b5b5b5;
  border-left: 1px solid #fff;
  font-size: 24px;
  text-align: center;
}
.risk_status div:nth-child(1).active {
  background-color: #009944;
}
.risk_status div:nth-child(2).active {
  background-color: #f9c75e;
}
.risk_status div:nth-child(3).active {
  background-color: #eb6100;
}
.risk_status div:nth-child(4).active {
  background-color: #dd352a;
}
.risk_status div:nth-child(5).active {
  background-color: #a01d18;
}
</style>